.input {
    width: calc(100% - 16px);
    border: 1px solid #777;
    border-radius: 5px;
    padding: 7px;
}
.input:focus {
    outline: none;
}
